import { useDispatch, useSelector } from "react-redux"
import { favoriteActions } from "../../../../../store/favorite-slice"

const Pagination = (props) => {

    let dispatch = useDispatch()
    const { index, favorites } = props
    let selectedpagination = useSelector(state => state.favorite.selectedpagination)

    return <button type='button' className={`w-auto mt-3 btn ${selectedpagination === index ? 'active' : ''}`} onClick={() => {
        dispatch(favoriteActions.setFilteredItems(favorites))
        dispatch(favoriteActions.setSelectedPagination(index))
    }}  >{index + 1}</button>


}

export default Pagination;
